export default "__VITE_ASSET__DKXYuJ9H__"